import SelectField from "../SelectField";
import { useFormContext } from "react-hook-form";
import DatePicker from "../DatePicker";
import InputTextArea from "../InputTextArea";
import { RootState } from "../../store/root-reducer";
import { connect } from "react-redux";
import { GoTrash } from "react-icons/go";
import { useTranslation } from "react-i18next";

function DamageBox({
  idx,
  item,
  onDelete,
  specificDamageOptions,
  specificLocationOptions,
  occuredReasonOptions,
  actionTakenOptions,
  damageTypesOptions,
}) {
  const { control, watch, setValue } = useFormContext();
  const { t } = useTranslation();
  const damageCategory = watch(`claimItemDamage.[${idx}].damage_category`);
  return (
    <div className="space-y-3">
      <div className="bg-[#F7F7F7] text-black font-semibold justify-between  min-h-8 rounded flex items-center px-2 gap-2 overflow-hidden">
        {t("Damage")} {idx + 1}
        {idx > 0 && (
          <button
            type="button"
            className=" hover:bg-red-100 p-1"
            onClick={() => onDelete(idx, item)}
          >
            <GoTrash color="#DB3C32" size={18} />
          </button>
        )}
      </div>
      <SelectField
        label={"Damage Category"}
        control={control}
        name={`claimItemDamage.[${idx}].damage_category`}
        options={damageTypesOptions}
        required
        onChange={() => {
          setValue(`claimItemDamage.[${idx}].specific_damage`, "");
        }}
        placeholder="Select Damage Category"
      />
      <SelectField
        label={"Specific Damage"}
        control={control}
        name={`claimItemDamage.[${idx}].specific_damage`}
        options={specificDamageOptions?.[damageCategory] || []}
        required
        disabledPlaceholder="Please select damage category first"
        disabled={!damageCategory}
        placeholder="Select Specific Damage"
      />
      <SelectField
        label={"Damage Area"}
        control={control}
        name={`claimItemDamage.[${idx}].damage_area`}
        options={specificLocationOptions}
        required
        placeholder="Select Damage Area"
      />
      <DatePicker
        label={"When did you notice the damage"}
        control={control}
        name={`claimItemDamage.[${idx}].when_did_you_notice_the_damage`}
        required
        placeholder="Select damage notice date"
      />
      <SelectField
        label={"How did it happen"}
        control={control}
        name={`claimItemDamage.[${idx}].how_did_it_happen`}
        options={occuredReasonOptions}
        required
        placeholder="Select How did it happen"
      />
      <SelectField
        label={"Did you take any steps to remedy ?"}
        control={control}
        name={`claimItemDamage.[${idx}].did_you_take_any_steps_to_remedy`}
        options={actionTakenOptions}
        required
        placeholder="Did you take any steps to remedy"
      />
      <InputTextArea
        label={"Note"}
        control={control}
        name={`claimItemDamage.[${idx}].note`}
        required
        placeholder="Describe more about damage"
      />
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  claimId: state?.claim.claimId || "",
});

export default connect(mapStateToProps)(DamageBox);
